import { render, staticRenderFns } from "./LandingLogo.vue?vue&type=template&id=3aa66aa0&scoped=true&"
import script from "./LandingLogo.vue?vue&type=script&lang=js&"
export * from "./LandingLogo.vue?vue&type=script&lang=js&"
import style0 from "./LandingLogo.vue?vue&type=style&index=0&id=3aa66aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa66aa0",
  null
  
)

export default component.exports